export const JOURNAL_COLUMNS = [
  { key: 'count', label: 'Кол-во', type: 'number' },
  { key: 'sowing', label: 'Посев', type: 'date', hint: 'Дата посева семян' },
  { key: 'germination', label: 'Всходы', type: 'date', hint: 'Дата полных всходов: семядоли появились над землёй у 70–80% посеянных семян' },
  { key: 'preseedling', label: 'Кол-во всходов', type: 'number' },
  { key: 'picking', label: 'Дата пикировки', type: 'date', hint: 'Дата пикировки сеянцев' },
  { key: 'seedling', label: 'Кол-во сеянцев', type: 'number' },
  { key: 'ground', label: 'Грунт', type: 'date', hint: 'Дата высадки рассады в теплицу или на грядку в открытый грунт' },
  { key: 'plants', label: 'Кол-во рассады', type: 'number' },
  { key: 'harvest', label: 'Урожай', type: 'date', hint: 'Дата сбора урожая' },
];
const defaults = ['count', 'sowing', 'germination', 'ground', 'harvest'];
export function printColumns(value) {
  const keys = value === undefined ? defaults : String(value).split(',');
  return [...new Set(keys)].map(key => JOURNAL_COLUMNS.find(column => column.key === key)).filter(Boolean);
}
export function printValue(value, type) {
  if (value === null || value === undefined || value === '') return '';
  if (type !== 'date') return String(value);
  const match = String(value).match(/^(\d{4})-(\d{2})-(\d{2})$/);
  return match ? `${match[3]}.${match[2]}` : '';
}
export function plantIsPerennial(seed) {
  return seed?.category?.parent_id === 101 || (seed?.params || []).some(param => param.name === 'growth_time' && (param.values && typeof param.values === 'object' && !Array.isArray(param.values) ? Object.keys(param.values) : [param.values].flat()).some(value => ['perennial', '69'].includes(String(value))));
}

export function printSeedWhere(gardenId, season, type) {
  const perennial = {_or:[{seed:{category:{parent_id:{_eq:101}}}},{seed:{params:{name:{_eq:'growth_time'},values:{_has_key:'perennial'}}}}]};
  return {garden_id:{_eq:gardenId},...(type==='perennial'?perennial:type==='all'?{_or:[{season:{_eq:season}},perennial]}:{season:{_eq:season}})};
}
export function plantInPrint(plant, season, type) {
  const perennial=plantIsPerennial(plant.seed);
  return perennial ? type!=='annual' : type!=='perennial' && String(plant.season)===String(season);
}
